import { PopupMenuComponent } from './popup-menu.component';
import { DemoMaterialModule } from './../../../demo-material-module';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

@NgModule({
    imports: [
        CommonModule,
        DemoMaterialModule,
        RouterModule
    ],
    declarations: [PopupMenuComponent],
    exports: [PopupMenuComponent],
    providers: [
    ]
})
export class PopupMenuModule { }
